import React, { FC } from 'react'
import { QuestionMarkCircleIcon } from '@heroicons/react/outline'
import { StyledQuestionMark } from '.'

type Props = {
  tooltip: string;
}

const QuestionMark: FC<Props> = ({ tooltip }) => {
  return (
    <StyledQuestionMark className="qm">
      <QuestionMarkCircleIcon />
      <div className="qm-tooltip">
        <span>{tooltip}</span>
      </div>
    </StyledQuestionMark>
  )
}

export default QuestionMark
